import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as A from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as M from "../../../models";
import { AppState } from "../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    abstractReviewer: state.abstractGrading.reviewerStats,
    loadingCareerCenter: state.careerCenter.loadingJobs || state.careerCenter.loadingResumes,
    jobs: state.careerCenter.userJobs,
    resumes: state.careerCenter.userResumes,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    loadAbstractReviewerStats: () => dispatch(A.AbstractGrading.loadReviewerStats()),
    loadJobs: () => dispatch(A.CareerCenter.loadUserJobs()),
    loadResumes: () => dispatch(A.CareerCenter.loadUserResumes()),
    toggleJobsLoading: (loading: boolean) => dispatch(A.CareerCenter.toggleJobsLoading(loading)),
    toggleResumesLoading: (loading: boolean) => dispatch(A.CareerCenter.toggleResumesLoading(loading)),
});

type OwnProps = RouteComponentProps<{}> & {
};

interface ConnectedState {
    abstractReviewer?: M.Abstract.ReviewerStats;
    loadingCareerCenter: boolean;
    jobs: List<M.CareerCenter.JobPost>;
    resumes: List<M.CareerCenter.Resume>;
}

interface ConnectedDispatch {
    loadAbstractReviewerStats: () => void;
    loadJobs: () => void;
    loadResumes: () => void;
    toggleJobsLoading: (loading: boolean) => void;
    toggleResumesLoading: (loading: boolean) => void;
}

interface OwnState {
}

class AccountComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public async componentDidMount() {
        if (this.props.jobs.size === 0)
            await this.props.toggleJobsLoading(true);
        if (this.props.resumes.size === 0)
            await this.props.toggleResumesLoading(true);

        this.props.loadJobs();
        this.props.loadResumes();
        this.props.loadAbstractReviewerStats();
    }

    public render() {
        const jobs = this.props.jobs;
        const resumes = this.props.resumes;
        // const reviewer = this.props.abstractReviewer;

        // const gradeAbstractsLink = reviewer && reviewer.isReviewer && reviewer.groupIds.length
        //     ? <Link to={Paths.User.AbstractGrading.Abstracts}>Grade Abstracts</Link>
        //     : null;

        const jobsLink = jobs.size
            ? <Link to={Paths.User.CareerCenter.Jobs}>{`Your Job Post${jobs.size === 1 ? "" : "s"}`}</Link>
            : <Link to={Paths.CareerCenter.Job.Post}>Post a Job</Link>;

        const resumesLink = resumes.size
            ? <Link to={Paths.User.CareerCenter.Resumes}>{`Your CV${resumes.size === 1 ? "/Resume" : "s/Resumes"}`}</Link>
            : <Link to={Paths.CareerCenter.Resume.Post}>Upload Resume</Link>;

        const title = "Your Account";

        return <Comp.Page.PublicPage pageTitle={title}>
            <div id="content-primary">
                <h1>{title}</h1>

                <Comp.Generic.Section title="Career Center">
                    <Comp.Generic.SectionLinks>
                        {jobsLink}
                        {resumesLink}
                    </Comp.Generic.SectionLinks>
                </Comp.Generic.Section>

                {/* <Comp.Generic.Section title="Abstracts">
                    <Comp.Generic.SectionLinks>
                        <Link to={Paths.User.Abstracts.UserAbstracts}>Your Abstracts</Link>
                        <Link to={Paths.AbstractsComposeNew(1)}>Submit an abstract</Link>
                        {gradeAbstractsLink}
                    </Comp.Generic.SectionLinks>
                </Comp.Generic.Section>

                <Comp.Generic.Section title="Financial disclosure">
                    <Comp.Generic.SectionLinks>
                        <Link to={Paths.User.FinancialDisclosureUpdate}>Update your financial disclosure</Link>
                    </Comp.Generic.SectionLinks>
                </Comp.Generic.Section> */}
            </div>

            <div id="content-secondary">

            </div>
        </Comp.Page.PublicPage>;
    }
}

export const Account: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/account/Account.tsx